import { createFileRoute, redirect } from '@tanstack/react-router';
import { resetLoginStore, useLoginStore } from '@/features/login/store';
import { userNeedToLogin } from '@/features/login/util/token';

export const Route = createFileRoute('/')({
    beforeLoad: async ({ location }) => {
        if (location.pathname !== '/') {
            return;
        }

        if (await userNeedToLogin()) {
            const { login, empresaIdpk } = useLoginStore.getState();
            if (!login || empresaIdpk) {
                resetLoginStore();
            }
            throw redirect({ to: '/auth/login' });
        }

        throw redirect({ to: '/a/painel-gerencial' });
    },
});
